<template>
  <div class="toutiao-modify-wrapper">
    <FixedHeader :value="currTaskId" @change="onTaskChange" @remove="onTaskTabRemove($event, onTaskChange)" :before-change="onTaskValidate">
      <FixedItem v-for="task in taskStates" :key="task.id" :data="task">
        <span>{{ task.id }}&ensp;</span>
        <em v-if="isDuplicate" @click.stop="onTaskDuplicate" class="el-icon-copy-document"></em>
        <em class="el-icon-loading" v-if="loadingTaskId == task.id"></em>
      </FixedItem>
    </FixedHeader>
    <div class="plan-modify ghost-button-styles" v-if="taskLoadFinished">
      <Moduler name="a" title="基础信息">
        <el-form :model="projectForm" ref="basicFormRef" :rules="getProjectFormRules.call(projectForm)" label-width="180px">
          <el-form-item label="投放账号" prop="accounts">
            <el-select
              style="width: 480px"
              v-model="projectForm.ad_account_id"
              @change="onProjectAccountChange"
              :disabled="adCreateType.isInherit"
              filterable
              clearable
              placeholder="请选择投放账号"
            >
              <el-option v-for="item in mediaAccountList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建方式">
            <el-radio-group v-model="projectForm.createType" v-if="isDuplicate">
              <el-radio-button ghost :label="CREATE_TYPE_ENUM.NEW">新建项目</el-radio-button>
              <el-radio-button v-if="!isV3" ghost :label="CREATE_TYPE_ENUM.INHERIT">使用原项目</el-radio-button>
            </el-radio-group>
            <el-radio-group v-model="projectForm.createType" disabled v-if="isModify">
              <el-radio-button ghost :label="CREATE_TYPE_ENUM.NEW">新建项目</el-radio-button>
              <el-radio-button ghost :label="CREATE_TYPE_ENUM.INHERIT">使用原项目</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="项目名称" v-if="adCreateType.isInherit">
            <el-input
              v-model="projectForm.project_name"
              style="width: 480px"
              clearable
              disabled
              placeholder="最大90个字符，1个中文等于2个字符"
            ></el-input>
          </el-form-item>

          <el-form-item label="计划名称" prop="plan_name">
            <el-input
              v-model="projectForm.plan_name"
              style="width: 480px"
              :disabled="isModify"
              clearable
              placeholder="最大90个字符，1个中文等于2个字符"
            ></el-input>
          </el-form-item>
          <el-form-item label="投放游戏">
            <el-input :value="gameName" style="width: 480px" disabled></el-input>
          </el-form-item>

          <el-form-item label="优化目标名称">
            <el-select
              style="width: 480px"
              :disabled="adCreateType.isInherit || (isModify && currTask.task_progress < 5)"
              v-model="projectForm.convertId"
              filterable
            >
              <el-option v-for="item in convertList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </Moduler>

      <template v-if="adCreateType.isNew">
        <Moduler name="a" title="营销目标及场景">
          <el-form
            label-width="180px"
            ref="marketingSceneFormRef"
            :validate-on-rule-change="false"
            :model="projectForm"
            :rules="getProjectFormRules.call(projectForm)"
          >
            <MarketingSceneForm :form="projectForm"> </MarketingSceneForm>
          </el-form>
        </Moduler>
      </template>

      <!-- 手动投放才能显示搜索快投 -->
      <template v-if="isManual && projectForm.ad_type === AD_TYPE.ALL">
        <Moduler name="a" title="搜索快投">
          <el-form
            label-width="180px"
            ref="keywordSearchFormRef"
            :validate-on-rule-change="false"
            :model="projectForm"
            :rules="getProjectFormRules.call(projectForm)"
          >
            <KeywordSearchForm :form="projectForm">
              <template #searchBidKeywordsSelectBtn>
                <el-button type="text" @click="onSearchKeywordAdd">编辑</el-button>
              </template>
            </KeywordSearchForm>
          </el-form>
        </Moduler>
      </template>

      <template v-if="adCreateType.isNew">
        <Moduler v-if="!isUnlimitedV3" name="a" title="版位及定向">
          <ToutiaoTargetingForm
            ref="toutiaoTargetingFormRef"
            label-width="180px"
            :is-procedural="isProcedural"
            :is-v3="isV3"
            ad-marketing-scene-disabled
          >
          </ToutiaoTargetingForm>
        </Moduler>

        <Moduler name="a" title="项目排期和出价设置">
          <el-form
            ref="bidFormRef"
            :validate-on-rule-change="false"
            :model="projectForm"
            :rules="getProjectFormRules.call(projectForm)"
            label-width="180px"
          >
            <BidForm :form="projectForm"> </BidForm>

            <el-form-item label="监测链接">系统自动生成</el-form-item>
          </el-form>
        </Moduler>
      </template>

      <Moduler name="a" title="计划创意">
        <PlanInfoForm ref="toutiaoPlanFormRef" label-width="180px" :project-form="projectForm" :ad-account="adAccount">
          <template #anchor="{ planForm }">
            <el-form-item label="锚点选择">
              <p v-if="planForm.anchor_material_list && planForm.anchor_material_list.length">
                {{ planForm.anchor_name }}
              </p>
              <el-button type="text" @click="showAnchorRelatedTypeModal = true">+选择锚点</el-button>
            </el-form-item>
          </template>

          <template #creatives>
            <el-form-item label="创意素材">
              <template v-if="currTask.plan.awemeIdentity === AMEME_TYPE.AWEME_VIDEO">
                <span v-if="!awemeVideoDataLoaded">
                  <span style="color: #999">达人视频素材加载中</span>
                  <span class="el-icon-loading"> </span>
                </span>

                <template v-else>
                  <CreativeBloggerConfigForm ref="creativeFormRef" :form.sync="currTask.creatives[0]" @remove="onAwemeVideoItemRemove">
                    <el-button type="text" @click="onShowAwemeCreativeSelector(false)">+添加素材</el-button>
                  </CreativeBloggerConfigForm>
                </template>
              </template>

              <template v-else>
                <CreativeConfigForm
                  ref="creativeFormRef"
                  :form.sync="currTask.creatives[0]"
                  :project-form="currTask.project"
                  @show-material-selector="onShowCreativeSelector()"
                  @replace="onShowRepalceMaterialSelector"
                >
                </CreativeConfigForm>
              </template>
            </el-form-item>
          </template>

          <template #titles="{ planForm }">
            <el-form-item label="创意标题" prop="title_material_list">
              <div class="title-input-row" v-for="(text, index) in planForm.title_material_list" :key="index">
                <el-input v-model="text.title"> </el-input>
                <span v-if="titleListCount > 1" class="remove el-icon-error" @click="removeTitleItem(index)"></span>
              </div>
              <span>
                <el-button type="text" @click="addTitleItem">+添加创意标题</el-button>
                <el-button type="text" @click="showTitleSelectModal">+选择创意标题</el-button>
                ({{ titleListCount }}/10)
              </span>
            </el-form-item>
          </template>

          <!-- 组件内部控制是否显示，ios一般不显示落地页 -->
          <template #landing-pages="{ planForm }">
            <el-form-item label="落地页" prop="web_url_material_list">
              <div class="landing-page-input-row" v-for="(page, index) in planForm.web_url_material_list" :key="index">
                <el-input v-model="planForm.web_url_material_list[index]" clearable>
                  <template #append>
                    <el-button type="text" @click="showLandingPageSelectModal(index)">&ensp;选择落地页&ensp;</el-button>
                  </template>
                </el-input>
                <span v-if="pageListCount > 1" class="remove el-icon-error" @click="removeLandingPageItem(index)"></span>
              </div>

              <span>
                <el-button type="text" @click="addLandingPageItem">+添加落地页</el-button>
                ({{ pageListCount }}/10)
              </span>
            </el-form-item>
          </template>
        </PlanInfoForm>
        <p style="margin-bottom: 100px"></p>
      </Moduler>
    </div>

    <div v-else style="height: calc(100vh - 150px)" v-loading="pageLoading"></div>

    <div class="ad-submit">
      <el-button @click="onTaskCancel">取消</el-button>
      <el-button
        type="primary"
        :disabled="pageLoading || queryAwemeVideoLoading"
        :loading="submitLoading"
        @click="onTaskSubmit(onTaskValidate)"
      >
        确认提交
      </el-button>
    </div>

    <AnchorRelatedTypeModal
      title="选择原生锚点"
      :current-row="{ ad_account_id: currTask.ad_account_id }"
      :visible.sync="showAnchorRelatedTypeModal"
      @confirm="onAnchorRelatedTypeConfirm"
      @cancel="onModifyModalCancel"
    >
    </AnchorRelatedTypeModal>

    <Document v-model="titleSelectorModal" :open-id="opId" @on-select="onTitleSelectConfirm" @on-cancel="onTitleSelectClose"></Document>

    <LandingPagesSelectorModal
      title="选择落地页"
      width="880px"
      :ad-account-id="adAccount.id"
      :visible.sync="landingPageSelectorModal"
      @cancel="onLandingPageSelectClose"
      @confirm="onLandingPageSelectConfirm"
    ></LandingPagesSelectorModal>

    <!-- 搜索快投选择弹窗 -->
    <SearchBidKeywordSelectModal
      v-model="showSearchBidKeywordModal"
      :account-id="accountId"
      :list="searchBidKeywordList"
      @confirm="onSearchKeywordSelectConfirm"
    ></SearchBidKeywordSelectModal>

    <el-dialog custom-class="custom-aweme-video-selector" title="选择达人视频" :visible.sync="showAwemeVideoSelectorModal" width="1240px">
      <AwemeVideoSelector
        v-if="showAwemeVideoSelectorModal"
        :star-task-id="currTask.project.star_task.star_task_id"
        @confirm="onAwemeSelectorConfirm($event, 0)"
        @close="showAwemeVideoSelectorModal = false"
      >
      </AwemeVideoSelector>
    </el-dialog>

    <!-- 素材选择弹窗 -->
    <!-- currTask.project.game 完成项目任务获取完毕后渲染  -->
    <el-dialog
      v-if="currTask.project.game"
      custom-class="material-selector-dialog"
      :close-on-click-modal="false"
      :visible.sync="showSelectorModal"
      title="素材选择"
      width="1200px"
      @close="onSelectorClose"
    >
      <AssetsSelector
        ref="assetsSelectorRef"
        v-bind="{ ...selectorProps, visible: showSelectorModal, selectedGameId: currTask.project.game.id }"
        @close="onSelectorClose"
        @confirm="onSelectorConfirm"
      >
        <!-- 图文账号选择和新建图文 -->
        <template v-slot:carouselAccount="{ getData }">
          <div v-show="selectorProps.assetType === MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE_AUDIO]">
            <div>
              <el-input style="width: 220px" disabled :value="currTask.accounts[0].adAccount"></el-input>
              <span>&ensp;</span>
              <el-button type="text" @click="onShowCarouselAddModal">+新建图文</el-button>
              <el-button type="text" @click="getData">刷新</el-button>
            </div>
            <p style="font-size: 12px; color: red">
              注意：选择的图文在创建计划时，会自动推送到其他账号中。不同主体的账号会推送失败，所选择的账号请使用相同主体
            </p>
          </div>

          <CarouselMaterialModal
            v-model="showCarouselAddModal"
            :account-id="selectorProps.adAccountId"
            @confirm="getData"
          ></CarouselMaterialModal>
        </template>

        <template v-slot:assetType="{ getData }">
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.VIDEO]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.VIDEO]"
          >
            视频
          </el-radio>

          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.IMAGE]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE]"
          >
            图片
          </el-radio>

          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.IMAGE_AUDIO]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.IMAGE_AUDIO]"
          >
            图文
          </el-radio>
          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.POSTER]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.POSTER]"
          >
            封面
          </el-radio>

          <el-radio
            v-model="selectorProps.assetType"
            :disabled="seletedMaterialRadioDiasbled[MATERIAL_TYPE.LOGO]"
            @change="getData"
            :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.LOGO]"
          >
            LOGO
          </el-radio>

          <el-radio v-model="selectorProps.assetType" @change="getData" :label="MATERIAL_TYPE_ID[MATERIAL_TYPE.FAV]"> 个人收藏 </el-radio>
        </template>

        <template v-slot:sizes="{ getData, width }">
          <el-select
            :style="{ width }"
            popper-class="creative-selector-el-select-popper"
            :popper-append-to-body="false"
            v-model="selectorProps.form.sizes"
            clearable
            multiple
            collapse-tags
            @change="getData"
          >
            <!-- 根据当前选择素材的类型来获取尺寸下拉数据 -->
            <el-option
              v-for="item in MATERIAL_TYPE_SIZES[selectorProps.assetType]"
              :key="item.label"
              :label="item.label"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </template>
      </AssetsSelector>
    </el-dialog>
  </div>
</template>

<script setup>
import Cookies from 'js-cookie'
import { clone } from '@/common/js/just.js'
import { provide, nextTick, watch, computed, set, ref } from 'vue'
import { FixedHeader, FixedItem } from '@/components/fixed-header/index.js'
import Moduler from '@/components/moduler'

import MarketingSceneForm from './components/project/marketing-scene-form.vue'
import KeywordSearchForm from './components/project/keyword-search-form.vue'
import ToutiaoTargetingForm from '@/views/promote/targeting/components/toutiao/targeting-form.vue'
import BidForm from './components/project/bid-form.vue'
import PlanInfoForm from './components/plan/plan-info-form.vue'
import CreativeConfigForm from './components/creative/creative-form.vue'
import CreativeBloggerConfigForm from './components/creative/creative-blogger-form.vue'
import { AssetsSelector } from '@/components/material-selector/index.js'
import CarouselMaterialModal from './components/creative/components/carousel-material/index.vue'
import LandingPagesSelectorModal from './components/creative/components/landing-pages/pages-modal.vue'
import SearchBidKeywordSelectModal from './components/project/components/search-bid.vue'
import Document from '@/views/create/toutiao_local/components/idea/document/document.vue'
import AnchorRelatedTypeModal from './components/preview-table/components/ad-anchor-related-type.vue'
import AwemeVideoSelector from './components/creative/components/aweme-video-selector/index.vue'
import { getToutiaoModifyForm } from './hooks/modify/index.js'

import { useToutiaoTask, useToutiaoData, useTitles, useLandingPages, useAnchorRelatedType } from './hooks/useToutiaoModify.js'
import { useSearchBid } from './hooks/useToutiaoBasic.js'
import { useProjectParamStates, usePageStates } from './hooks/useCommonComputeds.js'
import { useCreativeSelector, useCarouselSelector, useAwemeVideoCreatives, useAwemeVideoSelector } from './hooks/useToutiaoCreative.js'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
import { MATERIAL_TYPE_SIZES } from '@/views/create/bytedance/consts/creative.js'
import { AD_TYPE, AMEME_TYPE, ANCHOR_RELATED_TYPE, CREATE_TYPE_ENUM, MATERIAL_STYLE, PROJECT_AUDIENCE_TYPE } from './consts/index.js'

import { getProjectFormRules } from './rules/index.js'

import { initPageData, POPULAR_GAMES } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([POPULAR_GAMES])
const opId = Cookies.get('ch_op_id')
const gameList = computed(PAGE_REQUIRED_OPTS.POPULAR_GAMES)

const { isDuplicate, isModify } = usePageStates()

const {
  basicFormRef,
  keywordSearchFormRef,
  toutiaoTargetingFormRef,
  toutiaoPlanFormRef,
  marketingSceneFormRef,
  bidFormRef,

  adCreateType,
  pageLoading,
  submitLoading,
  taskList,
  adAccount,
  taskStates,
  originTasks,
  taskLoadFinished,
  taskIndex,
  currTask,
  convertList,
  projectForm,
  loadingTaskId,
  currTaskId,
  onAccountChange,
  handlePlanForm,
  handleTargetingForm,
  onTaskTabRemove,
  onTaskDuplicate,
  getTaskList,
  onTaskSubmit,
  onTaskCancel
} = useToutiaoTask()

// 根据当前任务平台区分游戏平台
const gameListFilteredByPlatform = computed(() => gameList.value.filter((item) => item.ch_platform_id === projectForm.value.ch_platform_id))
// 当前投放游戏
const gameName = computed(() => {
  const gameId = projectForm.value.game.id
  const { name } = gameListFilteredByPlatform.value.find((item) => item.id === gameId) || {}
  return name || gameId
})

const updateConfigForm = (form) => {
  currTask.value = form
}

const getAdAccount = () => adAccount.value

provide('configForm', {
  configForm: currTask,
  updateConfigForm
})

const isV3 = computed(() => Boolean(currTask.value.isV3))
const isUnlimitedV3 = computed(
  () => isV3.value && projectForm.value.audience_type === PROJECT_AUDIENCE_TYPE.UNLIMITED
)

provide('bytedanceVersion', { isV3 })

const { isReservation, isManual, isProcedural } = useProjectParamStates(projectForm)

const { mediaAccountList } = useToutiaoData()

const creativeFormRef = ref(null)

const currGroup = computed({
  get() {
    return currTask.value.creatives[0]
  },
  set(val) {
    currTask.value = {
      ...currTask.value,
      creatives: [val]
    }
  }
})
const creativeFormGroups = computed(() => currTask.value.creatives)
const onUpdateCreativeForm = (form) => {
  creativeFormRef.value.setForm(form)
}
const {
  showSelectorModal,
  selectorProps,
  seletedMaterialRadioDiasbled,
  onShowCreativeSelector,
  onShowRepalceMaterialSelector,
  onSelectorClose,
  onSelectorConfirm
} = useCreativeSelector(getAdAccount, currGroup, creativeFormGroups, onUpdateCreativeForm, currTask, updateConfigForm)

const { showCarouselAddModal, onShowCarouselAddModal } = useCarouselSelector()
const { awemeVideoGroupByAccountIdObj, queryAwemeVideoLoading, awemeVideoDataLoaded, getAwemeVideoListByAccountId } =
  useAwemeVideoCreatives(currTask)

// 当从其他类型切换到达人视频时，构造达人视频需要的参数结构
watch(
  () => currTask.value.plan.awemeIdentity,
  (awemeIdentity, prevValue) => {
    if (awemeIdentity === AMEME_TYPE.AWEME_VIDEO) {
      // 当从其他类型切换过来时，设置video为空
      set(currTask.value.creatives[0].selectedMaterials, 'video', [])
    }
  }
)

// 切换账号时，重新获取达人视频数据
const onProjectAccountChange = async (id) => {
  await onAccountChange(id)
  awemeVideoDataLoaded.value = false
  if (currTask.value.plan.awemeIdentity === AMEME_TYPE.AWEME_VIDEO) {
    handleAwemeVideoType({ ...currTask.value, ad_account_id: id }, taskIndex.value)
  }
}

const { showAnchorRelatedTypeModal, onModifyModalCancel, onAnchorRelatedTypeConfirm } = useAnchorRelatedType(toutiaoPlanFormRef, currTask)

const { showAwemeVideoSelectorModal, onShowAwemeCreativeSelector, onAwemeSelectorConfirm } = useAwemeVideoSelector(
  {},
  null,
  creativeFormGroups
)
const onAwemeVideoItemRemove = () => {}

const {
  titleListCount,
  titleSelectorModal,
  addTitleItem,
  removeTitleItem,
  showTitleSelectModal,
  onTitleSelectClose,
  onTitleSelectConfirm
} = useTitles(toutiaoPlanFormRef, currTask)

const {
  landingPageSelectorModal,
  pageListCount,
  addLandingPageItem,
  removeLandingPageItem,
  showLandingPageSelectModal,
  onLandingPageSelectClose,
  onLandingPageSelectConfirm
} = useLandingPages(toutiaoPlanFormRef, currTask)

const { accountId, showSearchBidKeywordModal, searchBidKeywordList, onSearchKeywordAdd, onSearchKeywordSelectConfirm } = useSearchBid(
  currTask,
  updateConfigForm
)

async function onTaskValidate() {
  try {
    const refs = adCreateType.value.isNew
      ? [basicFormRef.value, marketingSceneFormRef.value, toutiaoPlanFormRef.value, bidFormRef.value]
      : [basicFormRef.value]

    if (adCreateType.value.isNew && !isUnlimitedV3.value) {
      refs.splice(2, 0, toutiaoTargetingFormRef.value)
    }

    if (keywordSearchFormRef.value) {
      refs.push(keywordSearchFormRef.value)
    }

    // 如果广告是广告素材，需要校验创意表单，直播素材不需要校验素材表单
    if (currTask.value.plan.materials_type === MATERIAL_STYLE.PROMOTION_MATERIALS) {
      refs.push(creativeFormRef.value)
    }

    for (const formRef of refs.filter(Boolean)) {
      await formRef.validate()
    }

    if (adCreateType.value.isNew && !isUnlimitedV3.value) {
      handleTargetingForm()
    }

    handlePlanForm()

    return Promise.resolve()
  } catch (e) {
    console.log('onTaskValidate error output: ', e)
    const errorElement = document.querySelector('.el-form-item__error')
    errorElement?.scrollIntoView({ block: 'center', behavior: 'smooth' })
    return Promise.reject(e)
  }
}

function onTaskChange(taskId) {
  if (pageLoading.value) return
  if (currTaskId.value === taskId) return
  const originTask = originTasks.value.find((t) => t.taskId === taskId)
  initTask(originTask)
}

async function initTask(task) {
  pageLoading.value = true
  loadingTaskId.value = task.taskId

  const { filled } = taskStates.value.find((s) => s.id === task.taskId)
  taskLoadFinished.value = false
  await nextTick()

  // 已经填充过数据，取taskList里对应的数据，未填充过数据的，用getToutiaoModifyForm构建参数结构
  const taskForm = filled ? taskList.value.find((t) => t.taskId === task.taskId) : await getToutiaoModifyForm(task)
  const index = taskList.value.findIndex((t) => t.taskStates.id === task.taskId)
  // 达人视频素材根据账号获取达人视频列表
  if (taskForm.plan?.awemeIdentity === AMEME_TYPE.AWEME_VIDEO) {
    handleAwemeVideoType(taskForm, index)
  }

  // 为创意组件赋值
  // creativeFormGroups.value = [...taskForm.creatives]

  taskList.value.splice(index, 1, {
    taskStates: {
      id: taskForm.taskId,
      // getToutiaoModifyForm 单个任务回显后的标记，下次切换时不再调用
      filled: true
    },
    ...clone(taskForm)
  })

  taskLoadFinished.value = true
  currTaskId.value = task.taskId

  const [targetingForm] = taskForm.targetings
  nextTick(() => {
    // 为广告组件赋值
    toutiaoPlanFormRef.value.setForm(taskForm.plan)
    if (adCreateType.value.isNew && !isUnlimitedV3.value && targetingForm?.targetingParamJson) {
      // 为定向组件赋值，使用原项目时不需要定向参数
      toutiaoTargetingFormRef.value.setForm(targetingForm.targetingParamJson)
    }
  })
  setTimeout(() => {
    pageLoading.value = false
  }, 1000)
  loadingTaskId.value = 0
}

/**
 * @description: 处理达人视频素材显示
 * @param {*} taskForm
 * @param {*} index
 * @return {*}
 */
function handleAwemeVideoType(taskForm, index) {
  const adAccountId = taskForm.ad_account_id
  getAwemeVideoListByAccountId(adAccountId, taskForm.project).then(() => {
    const [creative] = taskForm.creatives
    const { video } = creative.selectedMaterials
    if (video?.length) {
      // video可能是视频素材或者是达人视频素材,只有达人视频素材才存在video_info属性
      const awemeItemIds = video.map((i) => i.video_info?.item_id).filter(Boolean)
      let awemeVideos = []
      // 找到账号下已选择的达人视频
      if (awemeItemIds?.length) {
        awemeVideos = awemeVideoGroupByAccountIdObj.value[adAccountId].filter((v) => awemeItemIds.includes(v.video_info.item_id))
        creative.account = adAccountId
        // creative.dyAccount = Array.isArray(awemeVideos) ? awemeVideos[0].aweme_id : ''
      }
      creative.selectedMaterials.video = awemeVideos
    } else {
      creative.selectedMaterials.video = []
    }

    taskForm.creatives = [creative]

    // 为创意组件赋值
    // creativeFormGroups.value = [creative]
    taskList.value.splice(index, 1, {
      taskStates: {
        id: taskForm.taskId,
        // getToutiaoModifyForm 单个任务回显后的标记，下次切换时不再调用
        filled: true
      },
      ...clone(taskForm)
    })
    awemeVideoDataLoaded.value = true
  })
}

getTaskList().then(() => {
  initTask(originTasks.value[0])
})
</script>

<style scoped lang="scss">
.toutiao-modify-wrapper {
  height: calc(100vh - 64px);
  overflow: auto;
}
.plan-modify {
  margin: 10px 15px;
}
.title-input-row,
.landing-page-input-row {
  display: flex;
  align-items: center;
  margin-bottom: 3px;
  .remove {
    margin-left: 10px;
    cursor: pointer;
  }
}

.ad-submit {
  position: sticky;
  bottom: 0;
  z-index: 999;
  text-align: right;
  background-color: #fff;
  padding: 20px 15px;
  border-top: 1px solid #eaeaea;
}
</style>
